<div class="container">
  <div class="left-rail" [innerHTML]="htmlSideNavigationContent"></div>
</div>
